export const MenuClasses = {
    EXPANDED: 'is--menu-expanded',
};
